import React, { Component, ErrorInfo, ReactNode } from "react";
import ErrorPage from "@/custolink-components/errors/ErrorPage";
import NewDesignErrorPage from "@/custolink-newdesign/pages/ErrorPage";
import axios from "axios"
import handleAxiosError from "@/custolink-logic/api/handleAxiosError";
import { isNewDesign } from "@/custolink-newdesign/flag";

interface Props {
  children: ReactNode;
  /**
   * True when this boundary's fallback mounts inside AppShell's content
   * column (the protected admin routes, OrganisationAllRoutes.tsx) rather
   * than standalone (the pre-auth AuthShell pages) - forwarded to the new
   * design's ErrorPage so it fills the column instead of claiming a fresh
   * viewport. See custolink-newdesign/pages/ErrorPage.tsx and
   * StatusScreen.tsx's `fullPage`.
   */
  inline?: boolean;
}

interface State {
  hasError: boolean;
  message:string;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    message:""
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    let message = "An error occurred. "
    if(axios.isAxiosError(error)){
      const m = handleAxiosError(error)
      if(m.errorMessage != null){
        message += m.errorMessage
      }
    }
    return { hasError: true, message };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);

  }

  public render() {
    if (this.state.hasError) {
      // Unlike RouteNotFound/RouteErrorBoundary, this is only ever mounted inside the /admin
      // route tree (OrganisationAllRoutes.tsx) - no asset-frontend/end_user route uses it - so
      // the admin switch alone is correct here, no pathname check needed.
      if (isNewDesign()) {
        return <NewDesignErrorPage message={this.state.message} inline={this.props.inline} />
      }
      return <ErrorPage message={this.state.message} />
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
